<template>
  <div class="motivate-add">
    <el-form
      :model="motivateForm"
      label-width="140px"
      style="padding-right: 20px"
      :rules="motivateRules"
      ref="motivateFormRefs"
      size="small"
    >
      <el-form-item label="名称" prop="incentiveName">
        <el-select
          v-model="motivateForm.incentiveName"
          @change="getRemark"
          placeholder="请选择名称"
          style="width: 100%"
          filterable
        >
          <el-option
            :label="item.name"
            v-for="item in incentiveList"
            :key="item.id"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对应师傅" prop="responsibleUserId">
        <el-select
          v-model="motivateForm.responsibleUserId"
          placeholder="请选择对应师傅"
          style="width: 100%"
          filterable
        >
          <el-option
            :label="item.userName"
            v-for="item in userList"
            :key="item.id"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="正/负激励备注" prop="incentiveRemarks">
        <el-input
          v-model="motivateForm.incentiveRemarks"
          disabled
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input
          v-model="motivateForm.remarks"
          type="textarea"
          maxlength="500"
        ></el-input>
      </el-form-item>
      <el-form-item label="金额" prop="amount">
        <el-input
          v-model="motivateForm.amount"
          placeholder="请输入金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="附件">
        <UpLoad
          :fileSize="100"
          ref="uploadRefs"
          :limit="100"
          @remove="removeFile"
          @uploadSuccess="handleUploadSuccess"
        ></UpLoad>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="warning"
          style="width: 100%"
          @click="related"
          >关联/查看订单</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UpLoad from "@/components/UpLoad";
import { validateNumber } from "@/utils/index";
export default {
  name: "MotivateAdd",
  components: {
    UpLoad,
  },
  props: {
    dialogFlag: {
      type: Boolean,
      default: false,
    },
    isStraight: {
      type: Boolean,
      default: false,
    },
    responsibleUserId: {
      type: Number,
      default: null,
    },
    userList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      motivateForm: {
        incentiveName: "",
        incentiveRemarks: "",
        remarks: "",
        amount: "",
        edIncentiveId: "",
        relatedOrderIds: [],
        attachmentIds: [], // 附件id
        incentiveAttachmentIds: [], // 正负激励备注附件id
        responsibleUserId: null, // 对应师傅ID
      },
      motivateRules: {
        incentiveName: [
          { required: true, message: "请选择名称", trigger: "change" },
        ],
        responsibleUserId: [
          { required: true, message: "请选择对应师傅", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { validator: validateNumber, trigger: "blur" },
        ],
      },
      incentiveList: [],
    };
  },
  watch: {
    dialogFlag: {
      handler(val) {
        if (val) {
          this.getIncentiveName();
          this.motivateForm.attachmentIds = [];
          // 设置默认师傅ID
          if (this.responsibleUserId) {
            this.motivateForm.responsibleUserId = this.responsibleUserId;
          }
        }
      },
      immediate: true,
    },
    responsibleUserId: {
      handler(val) {
        if (val && this.dialogFlag && !this.motivateForm.responsibleUserId) {
          this.motivateForm.responsibleUserId = val;
        }
      },
      immediate: true,
    },
    "motivateForm.attachmentIds": {
      handler(val) {
        if (val.length > 0) {
          this.getFileList(val);
        }
      },
      deep: true,
    },
  },
  methods: {
    getFileList(val) {
      this.axios({
        url: "/attachment/list",
        method: "POST",
        data: {
          ids: val.join(","),
        },
      }).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.fileList = res.data.data.map((item) => {
            return {
              name: item.fileName,
              url: item.fileUrl,
              uid: item.id,
            };
          });
          this.$refs.uploadRefs.fileList = this.fileList;
        }
      });
    },
    related() {
      this.$emit("related");
    },
    //    获取正负激励新增时的名称数据
    getIncentiveName() {
      this.axios({
        url: "/v1/web/routine-manage/incentive-manage/list",
        method: "post",
        data: {
          page: 1,
          size: 2000,
          queryInfoParams: {
            name: "",
          },
        },
      }).then((res) => {
        // 判断正负激励
        if (this.isStraight) {
          this.incentiveList = res.data.data.list.filter(
            (item) => item.incentiveType === 1
          );
        } else {
          this.incentiveList = res.data.data.list.filter(
            (item) => item.incentiveType === 0
          );
        }
      });
    },
    // 根据名称获取备注和附件id
    getRemark(val) {
      const item = this.incentiveList.find((item) => item.name === val);
      if (item) {
        this.motivateForm.incentiveRemarks = item.remarks;
        this.motivateForm.edIncentiveId = item.id;
        this.motivateForm.incentiveAttachmentIds = item.attachmentIds;
      } else {
        this.motivateForm.incentiveRemarks = "";
        this.motivateForm.edIncentiveId = "";
      }
    },
    handleUploadSuccess(res) {
      this.motivateForm.attachmentIds.push(res);
    },
    removeFile(file, fileList) {
      this.motivateForm.attachmentIds = fileList.map((item) => item.uid);
    },
  },
};
</script>

<style scoped></style>
